import { useSuspenseQuery } from "@apollo/client/react";

import {
  GetUserDetailDocument,
  type GetUserDetailQuery,
  type GetUserDetailQueryVariables,
} from "~/features/admin/users/gqls";

export function useUserDetail(userId: string) {
  return useSuspenseQuery<GetUserDetailQuery, GetUserDetailQueryVariables>(GetUserDetailDocument, {
    variables: { userId },
  });
}
